import React, {useRef, useState} from 'react';
import {Container} from "@material-ui/core";
import Button from "@material-ui/core/Button";
import makeStyles from "@material-ui/core/styles/makeStyles";
import { uploadImage } from '../api';
import EpmsImage from "../../Common/EpmsImage";
import {Link} from "react-router-dom";
import Navigation, {getNavigationUrl} from '../navigation';
import AppBar from "../Components/AppBar";
import Box from "@material-ui/core/Box";
import {useShoppingCart} from "../hooks/shoppingcart";
import SubHeader from "../Components/SubHeader";
import Typography from "@material-ui/core/Typography";
import {usePriceList} from "../../Providers/PriceListProvider";
import {Trans, useTranslation} from "react-i18next";
import {isElitefoto, useMetricSystem} from "../../../lib/common";

const useStyles = makeStyles(theme => ({
  centered: {
    textAlign: 'center'
  },
  hiddenInput: {
    display: 'none'
  },
  expandableFullHeight: {
    display: 'flex',
    flexDirection: 'column',
    minHeight: '100%'
  },
  imageListContainer: {
    backgroundColor: 'rgba(0, 0, 0, 0.06)',
    paddingTop: theme.spacing(2),
    paddingBottom: theme.spacing(2),
    width: '100%',
    overflowX: 'auto',
    flexShrink: 0,
  },
  imageList: {
    listStyle: 'none',
    margin: 0,
    padding: '0 0 0 ' + theme.spacing(2),
    whiteSpace: 'nowrap',
    display: 'flex'
  },
  imageContainer: {
    height: '96px',
    marginRight: theme.spacing(1),
    display: 'inline-block',
    [theme.breakpoints.up('md')]: {
      height: '30vh'
    }
  },
  image: {
    height: '100%'
  },
  infoText: {
    fontSize: '16px',
    flexGrow: 1
  },
  uploadDescription: {
    fontSize: '20px',
    lineHeight: '25px',
    textAlign: 'center'
  },
  uploadText: {
    textTransform: 'uppercase',
    marginBottom: '40px',
    textAlign: 'center',
    fontSize: '16px',
    fontWeight: 'bold'
  },
  progressBarContainer: {
    height: '10px',
    backgroundColor: '#ECECEC',
    width: '100%',
    position: 'relative'
  },
  uploadPage: {
    display: 'flex',
    flexDirection: 'column',
    height: '100%'
  },
  uploadContainer: {
    height: '100%',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    '& > div': {
      position: 'relative',
      top: '-71px'
    }
  },
  progressBar: {
    backgroundColor: 'black',
    position: 'absolute',
    left: 0,
    top: 0,
    height: '100%',
    width: '0'
  },
  fixedButtons: {
    backgroundColor: 'rgba(255, 255, 255, 0.7)'
  },
  uploadMoreButton: {
    marginRight: '2px'
  },
  adjustAndOrder: {
    marginLeft: '2px',
    textAlign: 'center'
  },
  imageErrorBox: {
    backgroundColor: '#ccc',
    height: '96px',
    marginRight: theme.spacing(1),
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    boxSizing: 'border-box',
    fontSize: '12px',
    maxWidth: '120px',
    textAlign: 'center',
    whiteSpace: 'break-spaces',
    padding: theme.spacing(2),
    [theme.breakpoints.up('md')]: {
      height: '30vh'
    }
  }
}));

export default () => {
  const classes = useStyles();
  const {updateCart} = useShoppingCart();

  let initialState = "UPLOAD_COMPLETE";
  initialState = 'WAITING_FOR_FILES'
  const [uploadStatus, setUploadStatus] = useState(initialState);
  const [totalFiles, setTotalFiles] = useState(0);
  const [uploadedFiles, setUploadedFiles] = useState([])
  const [currentUploadedFiles, setCurrentUploadedFiles] = useState([])
  const [fileProgress, setFileProgress] = useState(0);
  const {getProductByUuid, getSmallestPaperSize, getLargestPaperSize, getFormatSizeName} = usePriceList();
  const {t} = useTranslation();

  const fileRef = useRef(null);

  const openFileDialog = () => {
    fileRef.current.click();
  }

  const progressCallback = (pe) => {
      setFileProgress(pe.loaded / pe.total)
      console.log('Progress', pe);
  }

  const uploadFiles = async (files) => {
    console.log('Files', files);
    for (var file of files) {
      try {
        setFileProgress(0);
        const response = await uploadImage(file, progressCallback);
        console.log('Response', response);
        setUploadedFiles(arr => [...arr, response.files[0]])
        setCurrentUploadedFiles(arr => [...arr, response.files[0]])
      }
      catch (err) {
        console.log('Error', err);
      }
    }
  }

  const isHEIC = (fileObj) => {
      return new Promise((resolve) => {
        const r = new FileReader();
        const blob = fileObj.slice(0, 50);
        r.onload = (evt) => {
          const buffer = new Uint8Array(evt.target.result);
          if (buffer.length > 25 && buffer[20] === 0x68 && buffer[21] === 0x65 && buffer[22] === 0x69 && buffer[23] === 0x63) {
            console.log('Buffer is heic');
            resolve(true);
          }
          else {
            console.log('Buffer is not heic');
            resolve(false);
          }
        }
        r.onerror = (error) => {
          console.log('error loading image');
          resolve(false);
        }
        r.readAsArrayBuffer(blob);
      })
  }

  const asyncFilter = async (arr, predicate) => {
    const results = await Promise.all(arr.map(predicate));

    return arr.filter((_v, index) => results[index]);
  }

  const onUpload = async (e) => {
    if (e.target.files.length) {
      const arrFiles = Array.from(e.target.files)
      console.log('Files', arrFiles);
      const files =  await asyncFilter(arrFiles, async file => {
         console.log('Filtering list', file.type);
          if (file.type.startsWith('image')) {
            return true;
          }
          if (await isHEIC(file)) {
            return true;
          }
          return false;
      } )

      console.log('Filtered list is', files);

      if (files.length > 0) {
        setCurrentUploadedFiles([]);
        /*
        const tb = files.reduce( (totalBytes, file) => {
          console.log('File object', file);
           totalBytes += file.size;
        }, 0);
        setTotalBytes(totalBytes);
         */
        setUploadStatus('UPLOADING');
        setTotalFiles(files.length);
        uploadFiles(files).then(() => {
          setUploadStatus('UPLOAD_COMPLETE');
          updateCart();
        })
      }
    }
  }

  if (uploadStatus == 'UPLOADING') {
    const fileWidth = 100 / totalFiles;
    const progress = (currentUploadedFiles.length / totalFiles * 100) + (fileWidth * fileProgress);

    const progressStyle = {
      width: progress + '%'
    };
    return <div className={classes.uploadPage}>
      <AppBar />
      <Container className={classes.uploadContainer}>
        <Box>
          <p className={classes.uploadText}>
            {t('Uploading picture %d of %d', { postProcess: 'sprintf', sprintf: [currentUploadedFiles.length+1, totalFiles] })}
          </p>
          <div className={classes.progressBarContainer}>
            <div className={classes.progressBar} style={progressStyle} />
          </div>
        </Box>
      </Container>
    </div>
  }

  if (uploadStatus == 'UPLOAD_COMPLETE') {
    const formats = uploadedFiles.reduce((formats, image) => {
      if (image.error) {
        return formats;
      }
      if (typeof(formats[image.product.uuid]) == 'undefined') {
        const product = getProductByUuid(image.product.uuid);
        formats[image.product.uuid] = product;
      }
      return formats;
    }, {});

    const formatsList = Object.values(formats);

    const numFormats = formatsList.length;

    console.log('Formats list', formatsList)
    const formatNames =
        formatsList.map((f) => {
          return getFormatSizeName(f);
        })

     let formatString = formatNames.length > 0 && formatNames[0] || 'NA'
    if (formatNames.length > 1) {
      const firstFormats = formatNames.slice(0, formatNames.length-1).join(', ');
      const andFormatName = formatNames[formatNames.length - 1];
      formatString = sprintf(t('%s and %s'), firstFormats, andFormatName);
    }

    return <div className={classes.expandableFullHeight}>
      <AppBar disableGutters />
      <Container>
        <SubHeader>
          {t('%1$d picture(s) are added to the shopping cart', {
            postProcess: 'sprintf',
            sprintf: [uploadedFiles.filter(img => !img.error).length]
          })}
        </SubHeader>
      </Container>

      <Box display="flex" flexDirection="column" flex={1}>
        <div className={classes.imageListContainer}>
          <ul className={classes.imageList}>
            {uploadedFiles.map(file => {
              return <li key={file.uuid} className={classes.imageContainer}>
                {file.error ? <UploadErrorBox fileName={file.name} /> :
                  <EpmsImage uuid={file.uuid} className={classes.image}/>}
              </li>
            })}
          </ul>
        </div>
        <Container  className={classes.infoText} maxWidth='sm'>
          <Box mt={2} mb={2} >
            <Typography variant="h6"><Trans>Auto fit paper size</Trans></Typography>
            {uploadedFiles.length == 1 && <>
              <p dangerouslySetInnerHTML={{
                __html: t('The uploaded picture seems to best fit our %1$sstandard paper size %2$s.%3$s', { postProcess: 'sprintf', sprintf: ['<strong>', `${formatString}${useMetricSystem() ? 'cm' : '"'}`, '</strong>'] })}} />
              <p dangerouslySetInnerHTML={{
                __html: t('The picture is %sautomatically%s fitted to this format. You can review cropping or change the format in the next step.', { postProcess: 'sprintf', sprintf: ['<strong>', '</strong>'] })}} />
            </>}

            {uploadedFiles.length > 1 && numFormats == 1 && <>
              <p dangerouslySetInnerHTML={{
                __html: t('The uploaded pictures seem to best fit our %1$sstandard paper size %2$s.%3$s', { postProcess: 'sprintf', sprintf: ['<strong>', `${formatString}${useMetricSystem() ? 'cm' : '"'}`, '</strong>'] })}} />
              <p dangerouslySetInnerHTML={{
                __html: t('The pictures are %sautomatically%s fitted to this format. You can review cropping or change the format in the next step.', { postProcess: 'sprintf', sprintf: ['<strong>', '</strong>'] })}} />
            </>}

            {uploadedFiles.length > 1 && numFormats > 1 && <>
              <p dangerouslySetInnerHTML={{
                __html: t('The uploaded pictures seem to best fit our %1$sstandard paper sizes %2$s.%3$s', { postProcess: 'sprintf', sprintf: ['<strong>', `${formatString}${useMetricSystem() ? 'cm' : '"'}`, '</strong>'] })}} />
              <p dangerouslySetInnerHTML={{
                __html: t('The pictures are %sautomatically%s fitted to these formats. You can review cropping or change the format in the next step.', { postProcess: 'sprintf', sprintf: ['<strong>', '</strong>'] })}} />
            </>}
          </Box>
        </Container>
        <div className={classes.fixedButtons}>
          <Container>
            <Box display="flex" justifyContent="space-between" mt={2} mb={2}>
              <input type='file' className={classes.hiddenInput} ref={fileRef} onChange={onUpload} multiple={true} accept="image/*" />
              <Button onClick={openFileDialog} className={classes.uploadMoreButton} variant="contained" color="primary">
                <Trans>Upload more</Trans>
              </Button>
              <Button component={Link} to={Navigation.SHOPPING_CART} className={classes.adjustAndOrder} variant="contained" color="primary">
                <Trans>Adjust and order</Trans>
              </Button>
            </Box>
          </Container>
        </div>
      </Box>
    </div>
  }

  const smallestSize = getSmallestPaperSize();
  const largestSize = getLargestPaperSize();

  return <React.Fragment>
    <AppBar />
    <Container className={classes.container} maxWidth='sm'>
      <Box m={4} mt={6} className={classes.uploadDescription}>
        <p>
          {t('Choose sizes between %1$s and %2$s.', {
            postProcess: 'sprintf', sprintf: [
              `${smallestSize.width} x ${smallestSize.height}${useMetricSystem() ? ' cm' : '"'}`,
              `${largestSize.width} x ${largestSize.height}${useMetricSystem() ? ' cm' : '"'}`
            ]
          })}
        </p>
        <p>
          {isElitefoto() && <>Vi fremkaller på ekte fotopapir
            og tilbyr kort leveringstid – kun <b>to timer</b> ved henting i butikk!</>}
          {!isElitefoto() &&  <Trans>Enjoy your memories with high quality prints</Trans>}
            </p>
            <Box mt={6} mb={4}>
          <Button variant="contained" color="primary"  primarys onClick={openFileDialog} fullWidth>
            <Trans>Upload now</Trans>
          </Button>
        </Box>
      </Box>
      <input type='file' className={classes.hiddenInput} ref={fileRef} onChange={onUpload} multiple={true} accept="image/*" />
    </Container>
  </React.Fragment>
}

const UploadErrorBox = ({fileName}) => {
  const [t] = useTranslation();
  const classes = useStyles();

  return <div className={classes.imageErrorBox}>{t('The file %s is not supported', { postProcess: 'sprintf', sprintf: [fileName] })}</div>
}